/* global matchMedia */

import * as focusTrap from 'focus-trap'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { $ } from '../utils/query-selector.js'
import { tabbable } from 'tabbable'

const MENU_BREAKPOINT = '(min-width: 60em)' // 960px

class Menu {
  constructor ($el) {
    this.$el = $el

    this.$toggle = $('.js-menu__toggle', this.$el)
    this.$items = $('.js-menu__items', this.$el)
    this.$list = $('.js-menu__list', this.$el)

    this.$toggle.addEventListener('click', this.toggle.bind(this))

    this.mediaQuery = matchMedia(MENU_BREAKPOINT)
    // Use deprecated addListener method for backwards compatibility
    this.mediaQuery.addEventListener('change', this.setDesktopOrMobileMenu.bind(this))
    this.setDesktopOrMobileMenu()

    this.focusTrap = focusTrap.createFocusTrap(this.$el, {
      escapeDeactivates: true,
      clickOutsideDeactivates: true,
      onDeactivate: () => {
        this.toggle(false)
      },
      initialFocus: () => {
        for (const $el of tabbable(this.$list)) {
          if ($el !== this.$toggle) {
            return $el
          }
        }

        return false
      }
    })

    $('.js-menu__backdrop', $el).addEventListener('click', (e) => {
      this.toggle(false)
    })

    this.$el.classList.add('is-init')
  }

  isDesktop () {
    return this.mediaQuery.matches
  }

  toggle (force) {
    const oldState = this.$toggle.getAttribute('aria-expanded') === 'true'
    const newState = typeof force === 'boolean' ? force : !oldState

    if (oldState === newState) {
      return
    }

    if (newState && !this.isDesktop()) {
      window.scrollTo(0, 0)
    }

    this.$toggle.setAttribute('aria-expanded', newState.toString())

    this.$el.classList.toggle('is-open', newState)

    if (newState) {
      this.focusTrap.activate()
      disableBodyScroll(this.$list, {
        reserveScrollBarGap: true
      })
    } else {
      this.focusTrap.deactivate()
      enableBodyScroll(this.$list)
    }
  }

  setDesktopOrMobileMenu () {
    if (this.isDesktop()) {
      this.toggle(false)
    }
  }
}

(() => {
  const $el = $('.js-menu')
  if (!$el) {
    return
  }

  // eslint-disable-next-line no-new
  new Menu($el)
})()
